module.exports = __webpack_public_path__ + "static/media/jpimprovelogo.18f69f5a.svg";